import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getQuizReport = (
  classNames,
  fromDate,
  // pageNumber,
  // pageSize,
  // pageNumber = 1,
  pageNumber,
  pageSize = 20,
  toDate,
  userId,
  groupId,
  reportMode
) => {
  cancelToken = getAxiosCancelToken(cancelToken);

  const groupIds = groupId?.length > 0 ? groupId?.toString() : "";
  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.QUIZ_REPORT.GET_QUIZ_REPORT(
        classNames,
        fromDate,
        pageNumber,
        pageSize,
        toDate,
        userId,
        groupIds,
        reportMode
      ),
      "",
      cancelToken
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.QUIZ_REPORT.GET_QUIZ_REPORT(
          classNames,
          fromDate,
          (pageNumber = 0),
          (pageSize = 0),
          toDate,
          userId,
          groupIds,
          reportMode
        )
      );
    let template = "QuizPerformanceReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getQuizReport;
